import { combineReducers } from "redux";
import auth from "./auth";
import staff from "./staff";
import evaluationTerm from "./evaluationTerm";
import evaluationList from "./evaluationList";
import evaluationCategory from "./evaluationCategory";
import evaluationConfirm from "./evaluationConfirm";
import planningSheet from "./planningSheet";
import evaluationItem from "./evaluationItem";
import updateSticker from "./updateSticker";
import dataAnalysis from "./dataAnalysis";
import evaluationAnalysis from "./evaluationAnalysis";
import evaluationImplement from "./evaluationImplement";
import printing from "./printing";
import student from "./student";
import webEvaluation1 from "./webEvaluation1";
import webEvaluation2 from "./webEvaluation2";

export default combineReducers({
  auth,
  staff,
  evaluationTerm,
  evaluationList,
  evaluationCategory,
  evaluationConfirm,
  evaluationItem,
  planningSheet,
  updateSticker,
  dataAnalysis,
  evaluationAnalysis,
  evaluationImplement,
  printing,
  student,
  webEvaluation1,
  webEvaluation2
});
